import { useCallback, useState } from 'react';
import { read_pay_time_warning } from './pay_time_warning_rules';

// Holds the warning a dialog shows in place of its form. catch_warning(e) is true when the error was
// the 409 PAY_TIME_WARNING (now shown), so the caller skips its own error handling.
export default function usePayTimeWarning() {
  const [warning, setWarning] = useState(null);
  const clear = useCallback(() => setWarning(null), []);
  const catch_warning = useCallback((e) => {
    const w = read_pay_time_warning(e);
    if (w) setWarning(w);
    return !!w;
  }, []);
  return { warning, show: setWarning, clear, catch_warning };
}
